<template>
    <div v-if="charger">
        <div v-if="loading == true">
            <v-alert :icon="$vuetify.breakpoint.xs ? '' : 'info'" prominent text :type="$vuetify.breakpoint.xs ? '' : 'info'" color="info" border="top">
                <h2>Aguarde</h2>
                <br>
                Buscando informações.
            </v-alert>
        </div>
        <div v-else-if="online == false">
            <v-alert :icon="$vuetify.breakpoint.xs ? '' : 'error'" prominent text :type="$vuetify.breakpoint.xs ? '' : 'error'" color="error" border="top">
                <h2>Offline</h2>
                <br>
                Desculpe pelo transtorno, estamos com problema de internet no eletroposto.
                <br>
                <br>
                <v-btn tile block color="black white--text" :href="problemHref" target="_blank">
                    <v-icon left> fab fa-whatsapp </v-icon> Reportar Problema
                </v-btn>
            </v-alert>
        </div>
        <div v-if="online == true || isAdmin == true">
            <div class="mx-4" v-if="charger.numberPlugs > 1">
                <v-layout wrap v-if="selectedPlug">
                    <v-flex xs12 sm6 class="mb-0 pb-0 mb-sm-2 pb-sm-2">
                        <h2>Selecionado plug {{ selectedPlug }}</h2>
                    </v-flex>
                    <v-flex xs12 sm6 v-if="selectedPlug" class="mt-0 pt-0 mt-sm-2 pt-sm-2">
                        <v-btn block small color="secondary" @click="resetScreen">
                            <v-icon left> list </v-icon>Listar todos Plugs
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout wrap v-else>
                    <v-flex xs12 class="mb-0 pb-0 mb-sm-2 pb-sm-2">
                        <h2>Selecione o plug:</h2>
                    </v-flex>
                </v-layout>
            </div>
            <v-card-text>
                <div v-if="plugs != null">
                    <div v-for="plug of plugs" :key="plug.plug" class="mb-2">
                        <div v-if="selectedPlug != null" ref="selectedPlug">
                            <Plug :chargerName="chargerName" :charger="charger" :plug="plug" />
                        </div>
                        <div v-else>
                            <PlugToSelect :plug="plug" @selectPlug="userSelectPlug" />
                        </div>
                    </div>
                </div>
                <v-card dark color="primary" v-else>
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-card-title class="headline">Aguarde : )</v-card-title>
                            <v-card-subtitle>Buscando informações...</v-card-subtitle>
                        </div>
                        <v-avatar class="ma-3" size="50" tile>
                            <v-progress-circular size="50" width="10" color="grey" indeterminate />
                        </v-avatar>
                    </div>
                </v-card>
            </v-card-text>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Plug from "./Plug";
import PlugToSelect from "./PlugToSelect";

export default {
    props: {
        chargerName: {
            type: String,
            required: true,
        },
        charger: {
            required: true,
        },
    },

    components: { Plug, PlugToSelect },

    mounted() {
        this.isAdmin = this.verifyRole("ROLE_ADMIN");
        if (this.charger.numberPlugs == 1) {
            this.selectPlug(1);
        } else if (this.$route.params.plug) {
            this.selectPlug(this.$route.params.plug);
        } else {
            this.update();
        }
        this.timer = setInterval(this.update, 5000);
    },

    data() {
        return {
            isAdmin: false,
            plugs: null,
            timer: null,
            selectedPlug: null,
            online: false,
            loading: true,
            scrollOnLoad: false,
        };
    },

    computed: {
        ...mapGetters(["verifyRole"]),
        problemHref() {
            if (this.charger && this.charger.phone) {
                const phone = this.charger.phone.replace(/\D/g, "");
                return encodeURI(`https://wa.me/55${phone}?text=Estou com problema para utilizar o carregador ${this.chargerName}.`);
            } else {
                return encodeURI(`https://wa.me/5511973778065?text=Estou com problema para utilizar o carregador ${this.chargerName}.`);
            }
        },
    },

    methods: {
        userSelectPlug(plugNumber) {
            // Só rola quando o usuário escolhe o plug; vindo da URL ou com plug único, mantém o Header (cobrança) visível
            this.scrollOnLoad = true;
            this.selectPlug(plugNumber);
        },
        scrollToSelectedPlug() {
            this.$nextTick(() => {
                const el = this.$refs.selectedPlug && this.$refs.selectedPlug[0];
                if (el) {
                    // Desconta a faixa dos botões fixos do topo (menu/login) para não cobrir o componente
                    const topOffset = 100;
                    const visibleHeight = window.innerHeight - topOffset;
                    const elTop = el.getBoundingClientRect().top + window.pageYOffset;
                    // Se o componente for maior que a área visível, alinha pelo topo para não cortar o status
                    const margin = el.offsetHeight < visibleHeight ? (visibleHeight - el.offsetHeight) / 2 : 0;
                    window.scrollTo({ top: Math.max(elTop - topOffset - margin, 0), behavior: "smooth" });
                }
            });
        },
        selectPlug(plugNumber) {
            if (plugNumber <= this.charger.numberPlugs) {
                this.selectedPlug = plugNumber;
                this.plugs = null;
                this.loading = true;
                this.update();
            }
        },
        resetScreen() {
            this.scrollOnLoad = false;
            this.selectedPlug = null;
            this.plugs = null;
            this.loading = true;
            this.update();
        },
        update() {
            this.$http
                .get(this.selectedPlug ? `api/v2/now/${this.chargerName}/${this.selectedPlug}` : `api/v2/now/${this.chargerName}`, { showLoading: false })
                .then((result) => {
                    if (result) {
                        let online = true;
                        for (let i = 0; i < result.length; i = i + 1) {
                            // this.$emit("changeDetailsMode", (this.selectedPlug && result[i].status != "Available" && result[i].status != "Preparing"))
                            this.$emit("changeDetailsMode", (this.selectedPlug && result[i].status != "Available"))

                            if (result[i].online == 0) {
                                online = false;
                                break;
                            }
                        }
                        this.online = online;
                        this.plugs = result;

                        if (this.scrollOnLoad && this.selectedPlug) {
                            this.scrollOnLoad = false;
                            this.scrollToSelectedPlug();
                        }
                    } else {
                        this.plugs = null;
                    }
                })
                .catch(() => {
                    this.plugs = null;
                })
                .finally(() => {
                    this.loading = false;

                });
        },
    },

    beforeDestroy() {
        clearInterval(this.timer);
    },
};
</script>
